/**
 * "Right now" — the four pipeline counters above the order history, from the
 * prototype's Orders screen.
 *
 * The numbers are the server's KPI stats that ride along with every orders
 * fetch (`stats` on the list response, held in orderAnalyticsStore), so they
 * count the WHOLE pipeline, not the loaded page:
 *
 *   Packing         placed + picking
 *   Ready           packed — at the store, awaiting collection
 *   En route        dispatched + tracking + arrived
 *   Delivered today delivered since midnight
 */

import React from 'react';
import { Box } from '@mui/material';
import { Band, KpiTile } from '../../reskin/primitives';
import { useHUD } from '../context/HUDContext';

/** Stroke glyphs lifted from the prototype's tiles (24-box, no fill). */
const GLYPH = {
  packing: '<rect x="3" y="4" width="18" height="5" rx="1.5"/><path d="M5 9v10a1.6 1.6 0 0 0 1.6 1.6h10.8A1.6 1.6 0 0 0 19 19V9"/><path d="M10 13h4"/>',
  ready: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  enRoute: '<path d="M3 6.5h11v10H3z"/><path d="M14 9.5h3.6L21 13v3.5h-7z"/><circle cx="7" cy="18.6" r="1.7"/><circle cx="17.4" cy="18.6" r="1.7"/>',
  delivered: '<circle cx="12" cy="12" r="8.5"/><path d="M8.2 12.3l2.6 2.6 5-5.4"/>',
};

export default function RightNow() {
  const { stats } = useHUD();
  return (
    <>
      <Band live first>Right now</Band>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
          gap: 2,
        }}
      >
        <KpiTile glyph={GLYPH.packing} label="Packing" value={stats.waitingToPack} />
        <KpiTile glyph={GLYPH.ready} label="Ready" value={stats.packed} />
        <KpiTile glyph={GLYPH.enRoute} label="En route" value={stats.inTransit} />
        <KpiTile glyph={GLYPH.delivered} label="Delivered today" value={stats.deliveredToday} />
      </Box>
    </>
  );
}
